// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"wqc_Z","hidden":"d1sD8","overlay":"N7ApL","active":"_32uwg","poster":"_1P6wf","icon":"_1RXM2","transparency":"_3BLru"};